import { settingsContext } from "../contexts/SettingsContext";
import { useContext } from "react";

const useSettings = () => {
  const data = useContext(settingsContext);
  return data;
};

export default useSettings;
